import { RegisterSceneLoaderPlugin } from "@babylonjs/core/Loading/sceneLoader";
import { PmxReader } from "./Parser/pmxReader";
import { PmLoader } from "./pmLoader";
import { PmxLoaderMetadata } from "./pmxLoader.metadata";
/**
 * PmxLoader is a loader that loads the model in the PMX format
 *
 * PMX is a binary file format that contains all the data except the texture of the model
 */
export class PmxLoader extends PmLoader {
    /**
     * Create a new PmdLoader
     *
     * @param options babylon.js scene loader options
     * @param loaderOptions Overriding options, typically pass global PmxLoader instance as loaderOptions
     */
    constructor(options, loaderOptions) {
        super(PmxLoaderMetadata.name, PmxLoaderMetadata.extensions, options, loaderOptions);
    }
    createPlugin(options) {
        return new PmxLoader(options.mmdmodel, this);
    }
    async _parseFileAsync(arrayBuffer) {
        return await PmxReader.ParseAsync(arrayBuffer, this)
            .catch((e) => {
            return Promise.reject(e);
        });
    }
}
RegisterSceneLoaderPlugin(new PmxLoader());
